<template>
  <div>
    <draggable
      v-if="isSimulation && !isSecundary && isMenu"
      class="list-group"
      v-model="menus"
      group="menus"
      draggable=".list-group-item"
      @start="dragging = true"
      @end="dragging = false"
      @change="handleChangeSort"
    >
      <v-expansion-panels
	v-for="(item, index) in menus"
	:key="`mnu${index}`"
	:multiple="!isMenu && isSimulation"
	:disabled="!isMenu && isSimulation"
	v-model="item.expand"
	class="list-group-item"
      >
	<v-expansion-panel
	>
	  <menu-header
	    :data="item"
	    :isSecundary="isSecundary"
	    :onEdit="onEdit"
	    :onExpandMenu="handleExpandMenu"
	  />
	  <v-expansion-panel-content
	    style="padding: 0 !important"
	    :ref="`expContent_${item.ID}`"
	  >
	    <custom-menu 
	      v-if="!item.WebAppAsContent && item.Menus"
	      :data="item.Menus"
	      :onEdit="onEdit" 
	      isSecundary
	    />
	    <custom-menu 
	      v-else-if="item.WebAppAsContent && item.Menus"
	      :data="item.Menus.filter(x => x.IsActive && !x.HideMobile)"
	      :onEdit="onEdit" 
	      isSecundary
	    />
	    <custom-content
	      v-else
	      :id="item.ID"
	      :customBGColorContent="item.BGColorContent"
	      :customTextColorContent="item.TextColorContent"
	    />
	  </v-expansion-panel-content>
	</v-expansion-panel>
      </v-expansion-panels>
    </draggable>
    <v-expansion-panels
      v-else
      v-model="mainPanel"
      :multiple="!isMenu && isSimulation"
      :disabled="!isMenu && isSimulation"
    >
      <v-expansion-panel
	v-for="(item, index) in menus"
	:key="`mnu${index}`"
      >
	<menu-header
	  :data="item"
	  :isSecundary="isSecundary"
	  :onEdit="onEdit"
	  :onExpandMenu="handleExpandMenu"
	  class="list-group-item"
	/>
	<v-expansion-panel-content
	  style="padding: 0 !important"
	  :ref="`expContent_${item.ID}`"
	>
	  <custom-menu 
	    v-if="item.Menus"
	    :data="isSimulation ? item.Menus : item.Menus.filter(x => x.IsActive && !x.HideMobile)"
	    :onEdit="onEdit" 
	    isSecundary
	  />
	  <!-- <custom-content
	    v-else-if="expandMenu || (isSimulation && !isMenu)"
	    :expandMenu="expandMenu"
	    :id="item.ID"
	  /> -->
	  <custom-content
	    v-else
	    :id="item.ID"
	    :customBGColorContent="item.BGColorContent"
	    :customTextColorContent="item.TextColorContent"
	  />
	  <!-- <div
	    v-else-if="item.Type === 0 || 1===1"
	    :style="{ 'background-color': BGColorContent, 'color': ColorContent }"
	    style="padding: 0 10px 0 10px !important; text-align: justify;"
	  >
	    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
	  </div> -->
	</v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import draggable from 'vuedraggable'
  import MenuHeader from './MenuHeader'
  import CustomContent from './CustomContent'
  import CustomMenu from './Index'
  import api from '@/services/api'
  import constants from '@/constants'
  export default {
    name: 'custom-menu',
    components: {
      MenuHeader,
      CustomMenu,
      CustomContent,
      draggable,
    },
    props: {
      data: {
        type: Array,
        required: true
      },
      isSecundary: {
        type: Boolean,
        required: false,
        default: false
      },
      onEdit: {
        type: Function,
        required: false,
        default: null
      },
      expandFirstElement: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data: () => ({
      menus: [],
      mainPanel: [],
      expandMenu: null,
      dragging: false,
    }),
    computed: {
      ...mapState('app',['BGColorContent', 'ColorContent']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      borderRadius () {
        return this.isSimulation ? constants.borderRadius : null
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
    },
    watch: {
      data: {
        handler: function (newValue) {
          this.menus = newValue
          if (this.expandFirstElement && this.menus && this.menus.length > 0) {
            if(this.isSimulation ) {
              this.menus[0].expand = 0
            } else {
              this.mainPanel = 0
            }
          }
        },
        deep: true
      }
    },
    mounted () {
      this.menus = this.data
      this.mainPanel = this.isSimulation || this.expandFirstElement ? [1, 0] : []      
      if (this.expandFirstElement && this.menus && this.menus.length > 0) {
        if(this.isSimulation ) {
          this.menus[0].expand = 0
        } else {
          this.mainPanel = 0
        }
      }
    },
    methods: {
      handleChangeSort () {
        const body = this.menus.map((item, index) => {
          return ({
            ID: item.ID,
            ORD: index,
            Common: item.Common
          })
        })
        
        const bk =  JSON.parse(JSON.stringify(this.menus))
        this.$store.state.app.menus = []
        api.updateItem('menus', this.enterpriseID.concat('/sort'), body)
          .then(response => {
            this.$store.state.app.menus = bk
          })
        .catch(error => {
          console.log('error', error)
          this.$store.state.app.menus = bk
        })
      },
      handleExpandMenu (value) {
        // si no es simulación y es solo expandir el menú actualizamos las estadísticas
        if(!this.isSimulation && !this.$refs[`expContent_${value}`][0].isActive) this.handleSetStats(value)
        this.expandMenu = value
        
        // INI utilizado para la parrilla y que no se reproduzca cuando no esté activo el menu
        this.$store.state.app.expandMenuID = !this.$refs[`expContent_${value}`][0].isActive ? value : null
        // END utilizado para la parrilla y que no se reproduzca cuando no esté activo el menu

          // const element = this.$refs[`expContent_${value}`][0]
          // element.scrollIntoView();
  //         const element = document.getElementById(`exp_${value}`)
  //         const aux = element.parentElement.parentElement.parentElement.offsetTop
  //         const top = element.offsetTop
  //         window.scrollTo(0, top)
  //         console.log('jhm top', aux)
  //       const that = this
  //       setTimeout(function(){
  //         console.log('id', value)
  //         const element = that.$refs[`expContent_${value}`]
  //         const top = element.offsetTop
  //         console.log(top)
  //         window.scrollTo(0, top)
  //       }, 500);
      },
      handleSetStats (menu) {
        // añadimos los registros de accesos públicos
        api.setStats('stats', menu)
          .then(response => {
          })
          .catch(error => {
            console.log('error', error)
          })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .button {
    margin-top: 35px;
  }
  .flip-list-move {
    transition: transform 0s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .list-group {
    min-height: 20px;
  }
  .list-group-item {
    cursor: move !important;
  }
  .list-group-item i {
    cursor: pointer;
  }
  .list-group-item i {
    cursor: pointer;
  }
</style>
